import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { AutoSuggest } from "Components/Form";
import { Country } from "Models/country";

import { CountrySuggest } from "Components/Form/CountrySuggest";
import { TokenAction } from "Models/token.action";
import { AppTimezoneSelect } from "Components/Generic/AppTimezoneSelect";
import { Timezone } from "Models/timezone";

export default function AutoSuggestSection() {
  const [selectedCountries, setSelectedCountries] = useState<Country[]>([]);
  const [tokenAction, setTokenAction] = useState<TokenAction>({});
  const [selectedTimezone, setSelectedTimezone] = useState<Timezone | undefined>(undefined);

  const classes = useStyles();

  const { t: translate } = useTranslation();

  const countryOptions: Country[] = [
    { id: 1, name: "Brasil", code: "BR", valid: true },
    { id: 2, name: "Argentina", code: "AR", valid: true },
    { id: 3, name: undefined, code: "CH", valid: false },
    { id: 4, name: "Uruguai", code: "UY", valid: true },
  ];

  const handleTimezoneChange = (timezone: Timezone | undefined) => {
    console.log("Selected timezone:", timezone);
    setSelectedTimezone(timezone);
  };

  return (
    <>
      <div>
        <AutoSuggest<Country>
          required
          label={"AutoSuggest"}
          placeholder={"AutoSuggest"}
          multiple
          options={countryOptions}
          value={selectedCountries || []}
          getOptionLabel={(option) => option.name || option.code}
          getOptionSelected={(option, value) => option.id === value.id}
          onChange={(value) => {
            setSelectedCountries(value as Country[]);
          }}
        />
        <hr />
      </div>
      <div>
        <CountrySuggest
          label={"CountrySuggest"}
          placeholder={translate("australia")}
          country={tokenAction.country}
          onChange={(country) => {
            setTokenAction({ ...tokenAction, country, countryId: country?.id });
          }}
        />
        <hr />
      </div>
      <div>
        <AppTimezoneSelect
          value={selectedTimezone}
          handleChange={handleTimezoneChange}
          hasError={false}
          isReadonly={false}
          isLoading={false}
        />
      </div>
    </>
  );
}
